<template>
<div>
    <v-row no-gutters align="center" v-for="(work_hour, index) in item.meta.working_hours" :key="index">
        <v-col cols="4" class="text-xs-center">
            <p class="mb-0">{{work_hour.day}}</p>
        </v-col>
        <v-col cols="2">
            <v-switch v-model="work_hour.open" :label="showHours(work_hour.open)"></v-switch>
        </v-col>
        <v-col cols="4">
            <v-row v-if="work_hour.open" no-gutters align="center">
                <v-col cols="6" class="pa-1">
                    <v-menu :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="work_hour.start" label="Open hour" prepend-icon="access_time" readonly v-on="on" />
                        </template>
                        <v-time-picker format="24hr" v-model="work_hour.start" full-width></v-time-picker>
                    </v-menu>
                </v-col>
                <v-col cols="6" class="pa-1">
                    <v-menu :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="work_hour.end" label="Closed hour" prepend-icon="access_time" readonly v-on="on" />
                        </template>
                        <v-time-picker format="24hr" :min="work_hour.start" v-model="work_hour.end" full-width></v-time-picker>
                    </v-menu>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</div>
</template>

<script>
import defaults from "../../utils/PropDefaults.js";
export default {
    props: {
        item: {
            type: Object,
            default: function () {
                return this.$clone(defaults.place_item)
            }
        }
    },
    data() {
        return {
            // items: this.value,
        }
    },

    methods: {

        showHours(value) {
            if(value) {
                return "Open"
            } else {
                return "Closed"
            }
        }
    }
}
</script>
